import { TitleCasePipe } from '@angular/common';
import { MediaMarketTypeEnum, mediaMarketTypeToDisplayStringMap } from '../../../api/journodex/enum/media-market-type.enum';
import { MediaMarketApi } from '../../../api/journodex/model/media-market.api.model';
import { BaseModel } from '../../../Common/Basic/models/base.model';


export class MediaMarket extends BaseModel<MediaMarket, MediaMarketApi> {

    id: number;
    displayString?: string;
    type?: MediaMarketTypeEnum;
    isLocked?: boolean;

    constructor(apiModel?: MediaMarketApi) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        }
    }

    constructFromApiModel(apiModel: MediaMarketApi) {
        this.id = apiModel.id;
        this.displayString = this.convertDisplayStringToSentenceCase(apiModel.displayString);
        this.type = apiModel.type;
    }

    constructDefault() {}

    toApiModel(): MediaMarketApi {
        const apiModel: MediaMarketApi = {
            id: this.id,
            displayString: this.displayString,
            type: this.type
        };

        return apiModel;
    }

    clone(): MediaMarket {
        const clone = new MediaMarket();
        clone.id = this.id;
        clone.displayString = this.displayString;
        clone.type = this.type;
        return clone;
    }

    equals(other?: MediaMarket): boolean {
        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.type !== other.type) {
            return false;
        }

        return true;
    }

    getTypeDisplayString(): string {
        return mediaMarketTypeToDisplayStringMap.get(this.type);
    }

    private convertDisplayStringToSentenceCase(displayString: string): string {
        const titleCasePipe = new TitleCasePipe();
        const transformedSubRegions = [];
        const subRegions = displayString.split(' - ');
        for (const subRegion of subRegions) {
            const innerSubRegions = subRegion.split('(');
            let transformedInnerSubRegion = titleCasePipe.transform(innerSubRegions[0]);
            if (innerSubRegions.length > 1) {
                for (let i = 1; i < innerSubRegions.length; i++) {
                    transformedInnerSubRegion += ' (' + innerSubRegions[i];
                }
            }
            transformedSubRegions.push(transformedInnerSubRegion);
        }
        return transformedSubRegions.join(' - ');
    }
}
